import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionService } from '../../services/kampanje.service';
import { map, Observable, Subscription } from 'rxjs';
import { KampanjeCategoryFormComponent } from './kampanje-category-card/kampanje-category-form.component';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { ConfigService } from 'src/app/shared/config';

@Component({
    selector: 'app-kampanje-list',
    templateUrl: './kampanje-list.component.html',
    styleUrls: ['./kampanje-list.component.css'],
})
export class KampanjeListComponent implements OnInit {
    kampanjeSub: Observable<any>;
    user: User; // Declare the 'user' property
    kampanjeArr: any[] = []; // Declare the 'kampanjeArr' variable
    systems: any[] = [];
    categories: any[] = [];
    products: any[] = [];
    kampanjeByDay: { [key: string]: any[] } = {};
    daysOfWeek = [{ name: 'Monday', index: 1 }, { name: 'Tuesday', index: 2 }, { name: 'Wednesday', index: 3 }, { name: 'Thursday', index: 4 }, { name: 'Friday', index: 5 }, { name: 'Saturday', index: 6 }, { name: 'Sunday', index: 7 }];

    constructor(
        private subscriptionService: SubscriptionService,
        public dialog: MatDialog,
        private auth: AuthService,
        private config: ConfigService,


    ) {
        this.auth.user$.subscribe(user => this.user = user)
        this.loadKampanje();
        this.loadSystems();
        this.loadCategories();
        this.loadProducts();
    }


    ngOnInit(): void {
     
    }


    loadKampanje(): void {

        this.kampanjeSub = this.subscriptionService.getCategorySubscriptions().pipe(map(sp => {
            return sp.map((doc) => {
                return { id: doc.payload.doc.id, ...doc.payload.doc.data() }
            })
            // 
        }))
        this.kampanjeSub.subscribe(data => {
            this.kampanjeArr = data;
            this.kampanjeByDay = this.groupByDay(data);
        });
    }

    loadSystems(): void {
        this.subscriptionService.getSystems().subscribe((data: any) => {
            this.systems = data.sort((a, b) => (a.systemName || '').localeCompare(b.systemName || ''));
        })
    }

    loadCategories(): void {
        this.subscriptionService.getCategories().subscribe((data: any) => {
            this.categories = data.map((e: any) => {
                return {
                    id: e.payload.doc.id,
                    ...e.payload.doc.data(),
                };
            });
        });
    }

    loadProducts(): void {
        this.subscriptionService.getProducts().subscribe((data: any[]) => {
            this.products = data.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        });
    }

    // Short "what does this kampanje cover" line for the card.
    targetSummary(kampanje: any): string {
        const parts = [];
        const cats = (kampanje.categories || []).map(id => this.categories.find(c => c.id == id)?.name).filter(Boolean);
        const prods = (kampanje.products || []).map(id => this.products.find(p => p.id == id)?.name).filter(Boolean);
        if (cats.length) parts.push(cats.length > 2 ? `${cats.length} categories` : cats.join(', '));
        if (prods.length) parts.push(prods.length > 2 ? `${prods.length} products` : prods.join(', '));
        return parts.join(' + ');
    }

    private toSubscriptionData(formValue: any, selectedDays: any): any {
        return {
            companyId: this.config.getCompanyId(),
            systems: formValue.systems,
            categories: formValue.categories || [],
            products: formValue.products || [],
            name: formValue.name,
            startTime: `${formValue.startTime}`,
            endTime: `${formValue.endTime}`,
            percentage: formValue.percentage,
            selectedDays,
            active: formValue.active == "true" ? true : false,
            createdAt: moment().format('YYYY-MM-DD'),
            performedBy: this.user.email,
        };
    }

    createKampanje(): void {
        const dialogRef = this.dialog.open(KampanjeCategoryFormComponent, {
            width: '600px', // Set the width of the dialog
            data: { systems: this.systems, categories: this.categories, products: this.products }
        });
        dialogRef.afterClosed().subscribe((formValue) => {
            if (formValue) {
                // One doc per chosen day: the backend matches a single selectedDays value.
                const days: number[] = [].concat(formValue.selectedDays);
                const docs = days.map(day => this.toSubscriptionData(formValue, day));
                for (const doc of docs) {
                    const result = this.validateKampanje(doc);
                    if (result !== true) {
                        alert(result.message);
                        return;
                    }
                }
                docs.forEach(doc => this.subscriptionService.createCategorySubscription(doc));
            }
        });
    }


    // openSystemCategoryForm(): void {
    //     const dialogRef = this.dialog.open(KampanjeSystemCategoryComponent, {
    //         width: '600px', // Set the width of the dialog

    //     });

    //     dialogRef.afterClosed().subscribe((result) => {
    //         if (result) {
    //             // this.loadSubscriptions(); // Refresh the list after form submission
    //         }
    //     });
    // }
    editKampanje(eventData): void {
        const dialogRef = this.dialog.open(KampanjeCategoryFormComponent, {
            width: '600px', // Set the width of the dialog
            data: {
                eventData, systems: this.systems, categories: this.categories, products: this.products
            },
        });
        dialogRef.afterClosed().subscribe((formValue) => {
            if (formValue) {
                const subscriptionData = this.toSubscriptionData(formValue, formValue.selectedDays);
                const result = this.validateKampanje({ id: eventData.id, ...subscriptionData });
                if (result === true) {
                    this.subscriptionService.updateCategorySubscription(eventData.id, subscriptionData);
                } else {
                    alert(result.message);
                }
            }
        });
    }

    deleteKampanje(kampanje): void {
        this.subscriptionService.deleteCategorySubscription(kampanje.id).then(() => {
            // Handle success

        }).catch((error) => {
            // Handle error
        });
    }
    getCardColor(subscription: any): string {
        // Get current Oslo time as a Date object
        const osloTimeStr = new Date().toLocaleString('en-US', { timeZone: 'Europe/Oslo' });
        const currentOslo = new Date(osloTimeStr);


        // Get current day of week as a string (e.g., "Monday")
        const currentDay = moment().isoWeekday();

        // If the subscription is not scheduled for today, use a default color
        if (subscription.selectedDays !== currentDay) {
            return 'white';
        }

        // Parse the subscription start and end times into Date objects for today
        const start = this.parseTime(subscription.startTime, currentOslo);
        const end = this.parseTime(subscription.endTime, currentOslo);

        if (currentOslo < start) {
            // Upcoming subscription
            return 'lightblue';
        } else if (currentOslo >= start && currentOslo <= end) {
            // Currently active subscription
            return 'lightgreen';
        } else {
            // Subscription has ended for today
            return 'lightgray';
        }
    }

    parseTime(timeStr: string, referenceDate: Date): Date {
        // Expected format: "HH:MM AM/PM"
        const [timePart, modifier] = timeStr.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);

        if (modifier === 'PM' && hours < 12) {
            hours += 12;
        }
        if (modifier === 'AM' && hours === 12) {
            hours = 0;
        }

        // Create a new Date for the same day as referenceDate, in local time.
        // (We already converted the current time from Oslo so this works for our comparison.)
        return new Date(
            referenceDate.getFullYear(),
            referenceDate.getMonth(),
            referenceDate.getDate(),
            hours,
            minutes
        );
    }

    private groupByDay(subscriptions: any[]): { [key: string]: any[] } {
        const grouped: { [key: string]: any[] } = {};
        // Initialize the grouped object with empty arrays for each day.
        this.daysOfWeek.forEach(day => grouped[day.index] = []);

        subscriptions.forEach(subscription => {
            // Ensure the subscription's day is in our daysOfWeek list before grouping.
            if (grouped[subscription.selectedDays]) {
                grouped[subscription.selectedDays].push(subscription);
            } else {
                // If not, add it to a new group.
                grouped[subscription.selectedDays] = [subscription];
            }
        });
        return grouped;
    }

    // Refuses a kampanje that overlaps in time, on the same day and system,
    // with another kampanje covering the same category or product.
    validateKampanje(kampanje): any {
        const { startTime, endTime, systems, selectedDays } = kampanje;
        const categories = kampanje.categories || [];
        const products = kampanje.products || [];
        const dayName = this.daysOfWeek.find(d => d.index == selectedDays)?.name || selectedDays;

        for (const existingKampanje of this.kampanjeArr) {
            if (existingKampanje.id == kampanje.id || existingKampanje.selectedDays !== selectedDays) continue;

            const sharedSystem = (existingKampanje.systems || []).find((system: any) => systems.includes(system));
            if (!sharedSystem) continue;
            const sharedCategory = (existingKampanje.categories || []).find((cat: any) => categories.includes(cat));
            const sharedProduct = (existingKampanje.products || []).find((prod: any) => products.includes(prod));
            if (!sharedCategory && !sharedProduct) continue;

            const existingEndTime = Number(existingKampanje.endTime.replace(':', ''));
            const existingStartTime = Number(existingKampanje.startTime.replace(':', ''));
            const newStartTime = Number(startTime.replace(':', ''));
            const newEndTime = Number(endTime.replace(':', ''));

            if (Math.max(newStartTime, existingStartTime) <= Math.min(newEndTime, existingEndTime)) {
                const systemName = this.systems.find(sys => sys.systemId == sharedSystem)?.systemName || sharedSystem;
                const what = sharedProduct
                    ? `product ${this.products.find(p => p.id == sharedProduct)?.name || sharedProduct}`
                    : `category ${this.categories.find(cat => cat.id == sharedCategory)?.name || sharedCategory}`;
                return { success: false, message: `${dayName}: ${systemName} already has "${existingKampanje.name}" on ${what} at an overlapping time.` };
            }
        }
        return true; // No overlapping time found
    }

}


